import CustomField, {CustomFieldType} from "../../../model/customField/CustomField";
import {none, option, Option} from "ts-option";
import * as React from "react";
import Loading from "../../ui/loading/Loading";
import EnumDisplay from "./EnumDisplay";
import CustomFieldValue from "../../../model/job/CustomFieldValue";
import * as _ from "underscore";
import BooleanDisplay from "./BooleanDisplay";
import StringDisplay from "./StringDisplay";
import DateDisplay from "./DateDisplay";
import * as moment from 'moment';

interface ComponentProps {
	/**
	 * Fetch custom fields method
	 */
	fetchCustomFields: () => void;
	/**
	 * Create custom field value
	 * @param {CustomFieldValue} createdCustomFieldValue
	 */
	createCustomFieldValue: (createdCustomFieldValue: CustomFieldValue) => void;
	/**
	 * Update custom field value action.
	 * @param {CustomFieldValue} updatedCustomFieldValue
	 */
	updateCustomFieldValue: (updatedCustomFieldValue: CustomFieldValue) => void;
	/**
	 * Remove custom field value action.
	 * @param {string} customFieldValueId
	 */
	removeCustomFieldValue: (customFieldValueId: string) => void;
	/**
	 * Custom fields list.
	 */
	customFields: Option<CustomField[]>;
	/**
	 * Custom fields values
	 */
	customFieldsValues: Option<CustomFieldValue[]>;
}

export default class CustomFieldsDisplay extends React.Component<ComponentProps> {

	constructor(props: ComponentProps) {
		super(props);
		this.updateCustomFieldValue = this.updateCustomFieldValue.bind(this);
		this.removeCustomFieldValue = this.removeCustomFieldValue.bind(this);
	}

	componentDidMount() {
		if (!this.props.customFields.isDefined) {
			this.props.fetchCustomFields();
		}
	}

	render() {
		return (
			<Loading isLoading={this.props.customFields.isEmpty}>
				{this.props.customFields.getOrElse([]).map((field, index) =>
					<React.Fragment key={index}>{this.renderCustomField(field)}</React.Fragment>
				)}
			</Loading>
		);
	}

	renderCustomField(field: CustomField) {
		switch (field.fieldType) {
			case CustomFieldType.ENUM:
				return <EnumDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					items={field.options}
					label={field.label}
					selectedValue={this.getSelectedCustomFieldValue(field.id)}/>;
			case CustomFieldType.BOOLEAN:
				return <BooleanDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					label={field.label}
					selectedValue={this.getSelectedCustomFieldValue(field.id)}/>;
			case CustomFieldType.STRING:
				return <StringDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					label={field.label}
					value={this.getSelectedCustomFieldValue(field.id)}/>;
			case CustomFieldType.DATE:
				return <DateDisplay
					updateCustomFieldValue={(updatedValue: string) => this.updateCustomFieldValue(field.id, updatedValue)}
					removeCustomFieldValue={() => this.removeCustomFieldValue(field.id)}
					value={this.getSelectedCustomFieldValue(field.id).map(val => moment(val))}
					label={field.label}/>
		}
	}

	getSelectedCustomFieldValue(id: string): Option<string> {
		const selectedCustomFieldValue = _.find(this.props.customFieldsValues.getOrElse([]), (item) => item.customFieldId === id);
		return selectedCustomFieldValue ? selectedCustomFieldValue.value : none;
	}

	updateCustomFieldValue(customFieldId: string, updatedValue: string) {
		const currentCustomFieldValue = _.find(this.props.customFieldsValues.getOrElse([]),
			(item) => item.customFieldId === customFieldId);
		if (currentCustomFieldValue && updatedValue === '') {
			this.removeCustomFieldValue(currentCustomFieldValue.customFieldId);
		}
		else if (currentCustomFieldValue && updatedValue !== '') {
			this.props.updateCustomFieldValue(currentCustomFieldValue.copy({value: option(updatedValue)}));
		}
		else if (updatedValue !== '') {
			this.props.createCustomFieldValue(new CustomFieldValue(none, customFieldId, option(updatedValue)));
		}
	}


	removeCustomFieldValue(customFieldId: string) {
		const currentCustomFieldValue = _.find(this.props.customFieldsValues.getOrElse([]),
			(item) => item.customFieldId === customFieldId);
		if (currentCustomFieldValue) {
			this.props.removeCustomFieldValue(currentCustomFieldValue.id.get);
		}
	}
}